'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes.js');
var styleHelper = require('../../helper/styleHelper');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 图片轮播组件
 */
var ImageCarousel = React.createClass({
  render: function () {
    var indicatorCss = this.initIndicatorCss();
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var borderColor = styleHelper.getBorderColor(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    return (<div
      key="_"
      className="component-ImageCarousel"
      style={{
            width:w,
            height:h,
            borderColor : borderColor,
            borderWidth:1,
            clip : 'rect(0 0 ' + w + ' ' + h + ')',
            overflow : 'hidden',
            borderStyle:this.props.borderVisible?'solid':'none',
            backgroundColor:bgColor,
            position:'relative'
            }}>
      {this.props.children}
      {
        !this.props.items && (<canvas ref="canvas" width={w} height={h}></canvas>)
      }
      {
        this.props.isShowIndicator &&
        <div ref="indicatorLayer" className="indicator" style={{zIndex : 20}}>
          <ul style={indicatorCss.ul}>
            {
              this.props.items && this.props.items.map(function (itm, index) {
                return (
                  <li key={index} id={this.props.controlID + '-'+index}
                      style={indicatorCss.li}
                      onClick={this.onIndicatorClick.bind(this,index)}>
                    {
                      this.props.indicatorType === 'SiNumber' ? (index + 1) : ''
                    }
                  </li>);
              }, this)
            }
          </ul>
        </div>
      }
      {
        this.props.isShowIndicator && (
          <div ref="_left"
               className="go-left"
               style={{top : this.props.h/2 - 15}}
               onClick={this._onSkipClick.bind(this,-1)}
               onMouseOver={this._onMouseOver.bind(this,0)}
               onMouseOut={this._onMouseOut.bind(this,0)}></div>
        )
      }
      {
        this.props.isShowIndicator && (
          <div ref="_right"
               className="go-right"
               style={{
                  top : this.props.h/2 - 15}}
               onClick={this._onSkipClick.bind(this,1)}
               onMouseOver={this._onMouseOver.bind(this,1)}
               onMouseOut={this._onMouseOut.bind(this,1)}></div>
        )
      }
    </div>);
  },

  _onMouseOver: function (value) {
    var dom;
    if (value) {
      dom = $(ReactDOM.findDOMNode(this.refs._right))
    } else {
      dom = $(ReactDOM.findDOMNode(this.refs._left));
    }
    dom.animate({opacity: 1});
  },

  _onMouseOut: function (value) {
    var dom;
    if (value) {
      dom = $(ReactDOM.findDOMNode(this.refs._right))
    } else {
      dom = $(ReactDOM.findDOMNode(this.refs._left));
    }
    dom.animate({opacity: 0});
  },

  _onSkipClick: function (value) {
    var index = this.currentIndex + value;
    if (index >= this.imgs.length || index < 0) {
      return;
    }
    clearTimeout(this.timeOut);
    this.skipTo(index);
  },

  initIndicatorCss: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var Direction = appTypes.CarouselIndicatorDirection;
    var indicatorDirection = this.props.indicatorDirection;
    var indicatorType = this.props.indicatorType;
    var size = 12;
    var float = (indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM) ? 'left' : 'none';
    var color = '#000000';
    var bgColor = this.props.indicatorColor;
    var radius = indicatorType === appTypes.CarouselIndicatorType.CIRCLE ? '50%' : 0;
    var listStyle = 'none';
    var height = (indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT) ? h : size;
    var width = (indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT) ? (size + 4) : w;
    var top = (indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT) ? (h - height) / 2 : (indicatorDirection === Direction.TOP ? 10 : h - 10 - size);
    var left = (indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM) ? (w - width) / 2 : (indicatorDirection === Direction.LEFT ? 10 : w - 10 - size);
    var mh = (indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM) ? 3 : 0;
    var mv = (indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM) ? 0 : 3;

    var pt = 0;
    if (indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT) {
      height = this.props.items ? this.props.items.length * (size + 4 + mv * 2) + mv * 2 : size;
      top = (h - height) / 2;
    }

    var lineHeight = size + 'px';
    var liCss = {
      width: size,
      height: size,
      backgroundColor: bgColor,
      borderRadius: radius,
      borderStyle: 'solid',
      borderWidth: 2,
      marginLeft: mh,
      marginRight: mh,
      marginTop: mv,
      marginBottom: mv,
      lineHeight: lineHeight,
      listStyle: listStyle,
      display: 'inline-block',
      textAlign: 'center',
      overflow: 'hidden'
    };
    var ulCss = {
      left: left,
      top: top,
      width: width,
      height: height,
      textAlign: 'center',
      color: color,
      fontSize: 10,
      listStyle: listStyle,
      float: float,
      margin: 0,
      padding: 0,
      position: 'absolute'
    };

    return {
      ul: ulCss,
      li: liCss
    };
  },

  initSelLayer: function () {
    var index = parseInt(this.props.selectedIndex);
    var i;
    if (index < this.imgs.length) {
      for (i = 0; i < this.imgs.length; i++) {
        if (i === index) {
          $(this.imgs[i]).css({visibility: 'visible'});
        } else {
          $(this.imgs[i]).css({visibility: 'hidden'});
        }
      }
    }
  },

  componentDidMount: function () {
    this.resetCurrentIndex();
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    var i;
    var dom;
    this.imgs = [];
    if (this.props.items) {
      $(ReactDOM.findDOMNode(this.refs.indicatorLayer)).show();
      for (i = 0; i < this.props.items.length; i++) {
        dom = $('#' + this.props.items[i].controlID);
        dom.css({zIndex: 0});
        this.imgs.push(dom);
      }
      if (this.currentIndex < this.imgs.length) {
        dom = this.imgs[this.currentIndex];
      } else {
        dom = this.imgs[0];
      }
      if (dom) {
        dom.css({zIndex: 1})
      }
      this.initSelLayer();
      this.refreshIndicator();
      this.autoPlay();
    } else {
      $(ReactDOM.findDOMNode(this.refs.indicatorLayer)).hide();
      this.paintEmptyItem();
    }
    this.loadedCount = 0;
  },


  loadedCount: 0,

  onItemLoaded: function () {
    this.loadedCount++;
    if (this.loadedCount && this.loadedCount === this.props.items.length) {
      //this.refreshIndicator();
      //this.autoPlay();
    }
  },

  resetCurrentIndex: function () {
    this.currentIndex = parseInt(this.props.selectedIndex, 10);
  },

  paintEmptyItem: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var graphics;
    var self = this;
    var cx = this.props.w / 2;
    var cy = this.props.h - 15;
    var r = 8;
    var w;
    var h;
    if (canvas) {
      graphics = canvas.getContext('2d');
      this.requestID = window.requestAnimationFrame(function () {
        w = styleHelper.getWidth(self.props);
        h = styleHelper.getHeight(self.props);
        graphics.clearRect(0, 0, w, h);
        graphics.beginPath();
        graphics.strokeStyle = '#444';
        graphics.lineWidth = 1;
        graphics.rect(0.5, 0.5, w - 0.5, h - 0.5);
        graphics.moveTo(5, 5);
        graphics.lineTo(w - 5, h - 5);
        graphics.moveTo(5, h - 5);
        graphics.lineTo(w - 5, 5);
        graphics.closePath();
        graphics.stroke();

        graphics.beginPath();
        graphics.fillStyle = '#C7C7C7';
        graphics.arc(cx, cy, r, 0, 360);
        graphics.closePath();
        graphics.fill();

        graphics.beginPath();
        cx -= 25;
        graphics.fillStyle = '#F0F0F0';
        graphics.arc(cx, cy, r, 0, 360);
        graphics.closePath();
        graphics.fill();

        graphics.beginPath();
        cx += 50;
        graphics.arc(cx, cy, r, 0, 360);
        graphics.closePath();
        graphics.fill();
      });
    }
  },

  refreshIndicator: function () {
    var indicator;
    var i = 0;
    var l = 0;
    var opacity = 0.4;
    var borderColor;
    var margin;
    if (this.props.items) {
      l = this.props.items.length;
    }
    for (i; i < l; i++) {
      indicator = $('#' + this.props.controlID + '-' + i);
      if (i === this.currentIndex) {
        opacity = 0.8;
        borderColor = this.props.indicatorColor;
      } else {
        opacity = 0.5;
        borderColor = 'transparent';
      }
      indicator.css({
        opacity: opacity,
        borderColor: borderColor
      });
    }
  },


  animateDuration: 400,

  autoPlay: function () {
    var delay = parseInt(this.props.playInterval, 10);
    var self = this;
    if (this.props.aniType !== appTypes.StackPanelAniType.NONE) {
      delay -= this.animateDuration;
    }
    if (this.props.isAutoPlay) {
      this.timeOut = setTimeout(function () {
        var index = self.currentIndex + 1;
        if (index >= self.imgs.length) {
          index = 0;
        }
        self.skipTo(index);
      }, delay);
    }
  },

  nextLayer: undefined,
  previoursLayer: undefined,

  skipTo: function (index) {
    var previous;
    var next;
    var dom;
    var aniType = this.props.aniType;
    var i = 0;
    var targetOption = {
      duration: this.animateDuration,
      queue: false,
      complete: this.onSkipAnimateFinish
    };
    var currentOption = {
      duration: this.animateDuration,
      queue: false
    };

    var max = this.imgs.length;
    for (i; i < this.imgs.length; i++) {
      dom = this.imgs[i];
      if (i != this.currentIndex && i != index) {
        dom.css({display: 'none', visibility: 'hidden', zIndex: 0});
      } else {
        dom.css({display: 'block', visibility: 'visible'});
        if (i === this.currentIndex) {
          dom.css({zIndex: max - 1});
        } else if (i === index) {
          dom.css({zIndex: max})
        }
      }
    }
    previous = this.imgs[this.currentIndex];
    this.currentIndex = index;
    next = this.imgs[index];
    previous.css({'z-index': 0});
    next.css({'z-index': 1});
    this.nextLayer = next;
    this.previoursLayer = previous;
    switch (aniType) {
      case appTypes.StackPanelAniType.FADE :
        next.animate({opacity: 1}, targetOption);
        previous.animate({opacity: 0}, currentOption);
        break;
      case appTypes.StackPanelAniType.PUSH:
        previous.animate({left: -this.props.w}, currentOption);
        next.css({left: this.props.w}).animate({left: 0}, targetOption);
        break;
      case appTypes.StackPanelAniType.SLIDE:
        next.css({left: this.props.w}).animate({left: 0}, targetOption);
        break;
      case appTypes.StackPanelAniType.NONE:
        previous.css({display: 'none', zIndex: 0});
        next.css({left: 0, display: 'block', zIndex: max});
        this.onSkipAnimateFinish();
        break;
    }
  },

  onSkipAnimateFinish: function () {
    if (this.previoursLayer) {
      if (this.nextLayer) {
        if (this.previoursLayer !== this.nextLayer) {
          $(this.previoursLayer).css({display: 'none'});
        }
      }
    }
    this.refreshIndicator();
    this.autoPlay();
  },
  onIndicatorClick: function (index) {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.skipTo(index);
  },

  componentWillUnmount: function () {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    cancelAnimationFrame(this.requestID);
    this.resetCurrentIndex();
    this.refreshIndicator();
  }

});

module.exports = ImageCarousel;



// WEBPACK FOOTER //
// ./src/views/Components/ImageCarousel.jsx